"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/Modals/ApproveCallParticipant.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _ = require('web/components/VideoRooms/Room/Modals/');

// memo keeps connect()'s bailout on parent re-renders.
const ApproveCallParticipant = _react.memo.call(void 0, function ApproveCallParticipant () {
  const currentPendingUser = _hooks.useAppSelector.call(void 0, state =>
    _videoRoom.selectVideoRoomPendingUsersList.call(void 0, state).slice(-1)[0])

  if (!currentPendingUser) return null
  const {
    RoomKey, RoomAuthorizationKey, RoomAuthorizationUserName,
  } = currentPendingUser

  const respond = (Approved) => _actions2.default.respondVideoRoomJoinRequest({ RoomKey, RoomAuthorizationKey, Approved })

  return (
    _react2.default.createElement(_.ApproveCallParticipantModal, {
      isOpen: true,
      key: RoomAuthorizationKey,
      participantName: RoomAuthorizationUserName,
      onDeny: () => respond(false),
      onAllow: () => respond(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
    )
  )
})

exports. default = ApproveCallParticipant
